import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "@store/auth/auth";
import {
  destroyToken,
  getAdministratorToken,
  getToken,
  loginWithAppleToken,
  loginWithFacebookToken,
  resetPassword,
} from "./services";
import { type IResetPasswordRequest, type ITokenRequest } from "./types";

export const useGetTokenMutation = (reCaptchaToken?: string) =>
  useMutation({
    mutationFn: (data: ITokenRequest) => getToken(data, reCaptchaToken),
  });

export const useDestroyTokenMutation = () =>
  useMutation({
    mutationFn: destroyToken,
  });

export const useResetPasswordMutation = (reCaptchaToken?: string) =>
  useMutation({
    mutationFn: (data: IResetPasswordRequest) =>
      resetPassword(data, reCaptchaToken),
  });

export const useLoginWithFacebookTokenMutation = () =>
  useMutation({
    mutationFn: loginWithFacebookToken,
  });

export const useLoginWithAppleTokenMutation = () =>
  useMutation({
    mutationFn: loginWithAppleToken,
  });

export const useLoginAdministratorTokenMutation = () => {
  const { setToken } = useAuthStore();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: getAdministratorToken,
    onSuccess: (token) => {
      setToken(token);
      navigate("/");
    },
    retry: false,
  });
};
